import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer-section">
      <Container>
        <Row className="align-items-start justify-content-between">
          {/* Company Info & Social Media */}
          <Col lg={3} md={6} className="mb-4 mb-lg-0">
            <div className="footer-brand mb-4">
              <img 
                src="/logo.png" 
                alt="SpireNest Logo" 
                className="footer-logo mb-3"
              />
              <h5 className="footer-brand-name">SpireNest</h5>
              <p className="footer-description">
                Your trusted NetSuite partner for digital transformation and business growth.
              </p>
            </div>
            
            <div className="footer-social mb-4">
              <h6 className="footer-social-title">Follow Us</h6>
              <div className="social-links">
                <a href="https://x.com/spirenest" target="_blank" rel="noopener noreferrer" className="social-link">
                  <i className="bi bi-twitter-x"></i>
                </a>
                <a href="https://www.instagram.com/spire_nest/" target="_blank" rel="noopener noreferrer" className="social-link">
                  <i className="bi bi-instagram"></i>
                </a>
                <a href="https://www.youtube.com/@Spirenest" target="_blank" rel="noopener noreferrer" className="social-link">
                  <i className="bi bi-youtube"></i>
                </a>
                <a href="https://linkedin.com/company/spirenest" target="_blank" rel="noopener noreferrer" className="social-link">
                  <i className="bi bi-linkedin"></i>
                </a>
              </div>
            </div>
          </Col>

          {/* Services */}
          <Col lg={2} md={6} className="mb-4 mb-lg-0">
            <h6 className="footer-section-title">Services</h6>
            <ul className="footer-links">
              <li><Link to="/netsuite/services" className="footer-link">NetSuite Managed Services</Link></li>
              <li><Link to="/netsuite/services/implementation" className="footer-link">Implementation</Link></li>
              <li><Link to="/netsuite/services/support" className="footer-link">Support</Link></li>
              <li><Link to="/netsuite/services/staffing" className="footer-link">Staffing</Link></li>
              <li><Link to="/netsuite/services/financial" className="footer-link">NetSuite Financial</Link></li>
              <li><Link to="/netsuite/services/erp" className="footer-link">NetSuite ERP</Link></li>
              <li><Link to="/netsuite/services/crm" className="footer-link">NetSuite CRM</Link></li>
              <li><Link to="/netsuite/services/ecommerce" className="footer-link">NetSuite Ecommerce</Link></li>
            </ul>
          </Col>

          {/* Industries */}
          <Col lg={2} md={6} className="mb-4 mb-lg-0">
            <h6 className="footer-section-title">Industries</h6>
            <ul className="footer-links">
              <li><Link  to="/netsuite/industries/it-software"className="footer-link">IT & Software</Link></li>
              <li><Link  to="/netsuite/industries/wholesale-distribution" className="footer-link">Wholesale & Distribution</Link></li>
              <li><Link to="/netsuite/industries/manufacturing" className="footer-link">Manufacturing</Link></li>
              <li><Link to="/netsuite/industries/retail-ecommerce" className="footer-link">Retail & Ecommerce</Link></li>
              <li><Link to="/netsuite/industries/healthcare" className="footer-link">Healthcare</Link></li>
              <li><Link to="/netsuite/industries/finance-accounting" className="footer-link">Finance & Accounting</Link></li>
            </ul>
          </Col>

          {/* Company */}
          <Col lg={2} md={6} className="mb-4 mb-lg-0">
            <h6 className="footer-section-title">Company</h6>
            <ul className="footer-links">
              <li><Link to="/about" className="footer-link">About Us</Link></li>
              <li><Link to="/products" className="footer-link">Products</Link></li>
              <li><Link to="/contact" className="footer-link">Contact Us</Link></li>
              <li><Link to="/careers" className="footer-link">Careers</Link></li>
              <li><Link to="/privacy-policy" className="footer-link">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" className="footer-link">Terms of Service</Link></li>
              <li><Link to="/cookie-policy" className="footer-link">Cookie Policy</Link></li>
              <li><Link to="/legal" className="footer-link">Legal</Link></li>
            </ul>
          </Col>

          {/* Contact Info */}
          <Col lg={3} md={6}>
            <h6 className="footer-section-title">Contact Info</h6>
            <div className="footer-contact">
              <div className="contact-item">
                <div className="contact-icon">
                  <i className="bi bi-geo-alt-fill"></i>
                </div>
                <div className="contact-details">
                  <p>5886 Silhouette Ct,<br />Dublin, California,<br />USA 94568</p>
                </div>
              </div>
              
              <div className="contact-item">
                <div className="contact-icon">
                  <i className="bi bi-telephone-fill"></i>
                </div>
                <div className="contact-details">
                  <p>+1 (650) 9632560<br />24/7 Support Available</p>
                </div>
              </div>
              
              <div className="contact-item">
                <div className="contact-icon">
                  <i className="bi bi-envelope-fill"></i>
                </div>
                <div className="contact-details">
                  <p className='pt-2'>business@spirenest.co</p>
                </div>
              </div>
              
              {/* <div className="contact-item">
                <div className="contact-icon">
                  <i className="bi bi-clock-fill"></i>
                </div>
                <div className="contact-details">
                  <p>Mon - Fri: 9:00 AM - 6:00 PM<br />Sat: 10:00 AM - 4:00 PM</p>
                </div>
              </div> */}
            </div>
          </Col>
        </Row>

        {/* Bottom Section */}
        <div className="footer-bottom">
          <p className="footer-copyright text-center">
            © 2026 SPIRENEST TECHNOLOGIES, a DBA of PS NET IT SOLUTIONS LLC. All rights reserved.
          </p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
